import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';

const balancesApi = {
  recalculateClientBalance: async (clientId: string): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `clients/${clientId}/balance/recalculate`,
    );
  },
};

export default balancesApi;
